// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-c0e1f660] {\n  width: 1200px;\n  margin: 30px auto;\n}\n.agreement h1[data-v-c0e1f660] {\n    text-align: center;\n    margin-bottom: 30px;\n}\n.agreement *[data-v-c0e1f660] {\n    padding: 5px 0;\n}\n", ""]);
// Exports
module.exports = exports;
